import axios from 'axios'

const API_PREFIX = "/api/settings/pdpa"

export const apiUpdateTermsAndCondition = payload => {
    return axios.post(`${API_PREFIX}/private/terms_and_conditions`, payload)
}

export const apiGetTermsAndCondition = () => {
    return axios.get(`${API_PREFIX}/private/terms_and_conditions`)
}